export default __webpack_public_path__ + "static/media/avatar_placeholder_light.066fbfd4.svg";